








exports.default =
  props: ['total', 'value', 'icon_class']

  computed:
    percentage: ->
      total = @total || 1
      parseFloat(@value) * 100.0 / parseFloat(total) + '%'




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/vertical_bar.vue